import { UserManagementPermissions } from '../../permissions/user-management.permissions';
import { UserContext } from '../../../auth-management';
import { TranslateService } from '@ngx-translate/core';
import { SpecializedRolesEnum } from '../../../../../shared';
import { AccountTypeEnum } from '../../../system-management';

export const getUserManagementMenu = (userContext?: UserContext, translate?: TranslateService) => {
  const hasAccessToAccountManagement =
    userContext?.hasPermission(UserManagementPermissions.AccountsUsers.ReadAll) ||
    userContext?.hasPermission(UserManagementPermissions.AccountsSpecializedRoles.ReadAll);

  const hasAccessToSystemManagement =
    userContext?.hasPermission(UserManagementPermissions.Scopes.ReadAll) ||
    userContext?.hasPermission(UserManagementPermissions.Accounts.ReadAll) ||
    userContext?.hasSystemRole(UserManagementPermissions.Users.ReadAll);

  const hasAccessToUserManagement =
    (hasAccessToSystemManagement || hasAccessToAccountManagement) &&
    !userContext?.belongsToAccountOfType('ServiceProvider');

  return [
    {
      id: 1,
      label: translate ? translate.instant('MENUS.USER_MANAGEMENT') : 'User Management',
      isHidden: !hasAccessToUserManagement,
      icon: 'pi pi-user',
      expanded: true,
      subItems: [
        {
          id: 1,
          label: translate ? translate.instant('MENUS.ACCOUNTS_MANAGEMENT') : 'Accounts Management',
          expanded: true,
          isHidden: !hasAccessToAccountManagement,
          subItems: [
            {
              id: 1,
              label: translate ? translate.instant('MENUS.USERS') : 'Users',
              icon: 'pi pi-user',
              link: `/account-management/accounts/${userContext?.accountId}/users`,
              isHidden: !userContext?.hasPermission(UserManagementPermissions.AccountsUsers.ReadAll)
            },
            {
              id: 2,
              label: translate ? translate.instant('MENUS.SPECIALIZED_ROLES') : 'Specialized Roles',
              icon: 'pi pi-info-circle',
              link: `/account-management/accounts/${userContext?.accountId}/specialized-roles`,
              isHidden: !userContext?.hasPermission(UserManagementPermissions.AccountsSpecializedRoles.ReadAll)
            }
          ]
        },
        {
          label: translate ? translate.instant('MENUS.SYSTEM_MANAGEMENT') : 'System Management',
          expanded: true,
          isHidden: !hasAccessToSystemManagement,
          subItems: [
            {
              id: 1,
              label: translate ? translate.instant('MENUS.SYSTEM_USERS') : 'Users',
              icon: 'pi pi-user',
              link: '/user-management/users',
              isHidden: !userContext?.hasPermission(UserManagementPermissions.Users.ReadAll)
            },
            {
              id: 2,
              label: translate ? translate.instant('MENUS.SYSTEM_ACCOUNTS') : 'Accounts',
              icon: 'info-circle',
              link: '/user-management/accounts',
              isHidden: !userContext?.hasPermission(UserManagementPermissions.Accounts.ReadAll)
            },
            {
              id: 3,
              label: translate ? translate.instant('MENUS.SYSTEM_SCOPES') : 'Scopes',
              icon: 'info-circle',
              link: '/user-management/scopes',
              isHidden: !userContext?.hasPermission(UserManagementPermissions.Scopes.ReadAll)
            }
          ]
        }
      ]
    },
    {
      id: 2,
      label: translate ? translate.instant('MENUS.STAFF_ACCOUNTS') : 'Staff Accounts',
      icon: 'pi pi-user',
      link: `/account-management/accounts/${userContext?.accountId}/staff-accounts`,
      isHidden: !userContext?.isAdminWithPermissionAndBelongsToAccountType(
        UserManagementPermissions.AccountsUsers.ReadAll,
        'ServiceProvider',
        SpecializedRolesEnum.PROVIDER_ADMIN
      )
    },
    {
      id: 3,
      label: translate ? translate.instant('MENUS.ROLES') : 'Roles',
      icon: 'pi pi-check-circle',
      link: `/account-management/accounts/${userContext?.accountId}/roles`,
      isHidden: !userContext?.isAdminWithPermissionAndBelongsToAccountType(
        UserManagementPermissions.AccountsUsers.ReadAll,
        'ServiceProvider',
        SpecializedRolesEnum.PROVIDER_ADMIN
      )
    }
  ];
};

export const getProviderAdminUserManagementMenu = (userContext?: UserContext, translate?: TranslateService) => {
  return [
    {
      id: 4,
      label: translate ? translate.instant('MENUS.STAFF_ACCOUNTS') : 'Staff Accounts',
      icon: 'pi pi-user',
      link: `/account-management/accounts/${userContext?.accountId}/staff-accounts`,
      isHidden: !userContext?.isAdminWithPermission(
        UserManagementPermissions.AccountsUsers.ReadAll,
        SpecializedRolesEnum.PROVIDER_ADMIN
      )
    },
    {
      id: 5,
      label: translate ? translate.instant('MENUS.ROLES') : 'Roles',
      icon: 'pi pi-check-circle',
      link: `/account-management/accounts/${userContext?.accountId}/roles`,
      isHidden: !userContext?.isAdminWithPermission(
        UserManagementPermissions.AccountsUsers.ReadAll,
        SpecializedRolesEnum.PROVIDER_ADMIN
      )
    }
  ];
};
